import {ItauSdkCoreAnalyticsModule} from '@app-analytics/analytics';
import {HttpClientModule} from '@angular/common/http';
import {NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, APP_INITIALIZER} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginModule} from './login/login.module';
import {createCustomElement} from '@angular/elements';
import {APP_BASE_HREF, CommonModule} from '@angular/common';
import {FormsProposalModule} from './forms/forms.module';
import {SellerPfModule} from './forms/seller-pf/seller-pf.module';
import {FormsModule} from '@angular/forms';
import {SellerPjModule} from './forms/seller-pj/seller-pj.module';
import {SharedModule} from './shared/shared.module';
import {AppInitService} from "./app-init.service";
import {provideConnectAngular} from "@quickweb/connect-angular";
import { PropertyDivisionPjModule } from './forms/property-division/property-division-pj/property-division-pj.module';
import { PropertyDivisionPfModule } from './forms/property-division/property-division-pf/property-division-pf.module';

export function appInitializerFactory(appInitService: AppInitService) {
  return () => appInitService.init();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    LoginModule,
    FormsProposalModule,
    BrowserModule,
    RouterModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ItauSdkCoreAnalyticsModule,
    HttpClientModule,
    SellerPfModule,
    SellerPjModule,
    PropertyDivisionPjModule,
    PropertyDivisionPfModule,
    FormsModule,
    CommonModule,
    SharedModule,
  ],
  // bootstrap: [AppComponent],
  entryComponents: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [AppInitService],
      multi: true,
    },
    {provide: APP_BASE_HREF, useValue: './'},
    provideConnectAngular(),
  ],
})
export class AppModule implements DoBootstrap {

  constructor(public injector: Injector) {
    const custom = createCustomElement(AppComponent, {injector});
    customElements.define('mfeacompanhamento-proposta', custom);
    (window as any)._containerGTM = 'GTM-KSB5C24G'; //CONTAINER GTM DE PRODUCAO
  }

  ngDoBootstrap(): void {
    // tslint:disable-next-line:max-line-length
    // const elem = createCustomElement(AppComponent, { injector: this.injector }); // nessa linha criamos o Custom Element para o "AppComponent"
    // tslint:disable-next-line:max-line-length
    // customElements.define('mfeacompanhamento-proposta', elem); // nessa linha criamos a tag customizada (Custom Element) que será <meu-projeto-angular></meu-projeto-angular>
  }
}
